import { Injectable } from '@angular/core';
import { first } from 'lodash-es';
import { NEVER } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Notification } from 'src/app/models/domain';
import { NotificationDataService } from 'src/app/services';
import { handleError } from './akita-error-helper';
import { CollectionState } from './collection-state';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly state = new CollectionState<Notification>(true);

  public readonly notifications$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  /** `loadByEquipmentNumber` fetches a single ZE notification, so this is it. */
  public readonly newestZE$ = this.notifications$.pipe(map(first));

  public constructor(private readonly notificationDataService: NotificationDataService) {}

  public loadByEquipmentNumber(equipmentNumber: string) {
    this.state.setLoading(true);

    return (
      this.notificationDataService
        // Only fetch the newest notification
        .getByEquipmentNumberAndNotificationType(equipmentNumber, ['ZE'], { perPage: 1, page: 1 })
        .pipe(
          tap((notifications) => {
            this.state.set(notifications);
          }),
          catchError((error) => {
            handleError(this.state, error);

            return NEVER;
          }),
          map(() => undefined)
        )
    );
  }

  public reset() {
    this.state.reset();
  }
}
